import { clsx } from 'clsx'
import { memo } from 'react'

export type TextRotation = 0 | 180

const SMALL_S_FONT_THRESHOLD = 14
const SMALL_XS_FONT_THRESHOLD = 19

type Props = {
  angle: number
  translate: string
  label: string
  textRotation: TextRotation
}

export default memo(function WheelLabel({ angle, translate, label, textRotation }: Props) {
  const fontSize = getFontSize(label)

  return (
    <text
      className={clsx('font-sans text-shadow-[0_0_10px_rgb(0_0_0_/_0.70)]', fontSize)}
      transform={`rotate(${angle}) translate(${translate}) rotate(${textRotation})`}
      dy="0.37em"
    >
      {label}
    </text>
  )
})

function getFontSize(label: string): string {
  if (label.length > SMALL_XS_FONT_THRESHOLD) {
    return 'xs-font'
  } else if (label.length > SMALL_S_FONT_THRESHOLD) {
    return 's-font'
  } else {
    return ''
  }
}
